module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', {
          staticClass: "form-accept"
        }, [_c('v-btn', _vm._g({
          attrs: {
            "fixed": "",
            "large": "",
            "dark": "",
            "fab": "",
            "bottom": "",
            "color": "#0099E1"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('update:snackbar', false);
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "x-large": ""
          }
        }, [_vm._v("check")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbarNotification,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbarNotification = $event
      }
    }
  }), _vm._v(" "), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("Equipo")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    model: {
      value: (_vm.validInput),
      callback: function($$v) {
        _vm.validInput = $$v
      },
      expression: "validInput"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de equipo*",
      "items": _vm.allDeviceTypes,
      "item-text": "label",
      "item-value": "id",
      "color": "0099E1",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nombre de equipo*",
      "color": "0099E1",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nombre del lote*",
      "color": "0099E1",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.lotName),
      callback: function($$v) {
        _vm.lotName = $$v
      },
      expression: "lotName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Largo del equipo [m]*",
      "color": "0099E1",
      "type": "number",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.equipmentLength),
      callback: function($$v) {
        _vm.equipmentLength = $$v
      },
      expression: "equipmentLength"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Caudal [m3/h]*",
      "color": "0099E1",
      "type": "number",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.pumpFlow),
      callback: function($$v) {
        _vm.pumpFlow = $$v
      },
      expression: "pumpFlow"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Superficie (has)*",
      "color": "0099E1",
      "type": "number",
      "rules": _vm.requiredRule
    },
    model: {
      value: (_vm.equipmentArea),
      callback: function($$v) {
        _vm.equipmentArea = $$v
      },
      expression: "equipmentArea"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.allCropTypes,
      "item-text": "label",
      "item-value": "id",
      "label": "Cultivos",
      "color": "0099E1",
      "multiple": ""
    },
    model: {
      value: (_vm.cropTypes),
      callback: function($$v) {
        _vm.cropTypes = $$v
      },
      expression: "cropTypes"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('small', [_vm._v("*datos requeridos")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onCancel()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": _vm.disableCreation
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }, [_vm._v("Registrar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-226448bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/new/DeviceCreationForm.vue
// module id = 760
// module chunks = 21